import { useSyncExternalStore } from "react";

let connected = false;
const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) listener();
}

export function setRealtimeNotifyConnected(next: boolean): void {
  if (connected === next) return;
  connected = next;
  emit();
}

export function getRealtimeNotifyConnected(): boolean {
  return connected;
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** True when SignalR hub is connected — inbox poll can pause. */
export function useRealtimeNotifyConnected(): boolean {
  return useSyncExternalStore(
    subscribe,
    getRealtimeNotifyConnected,
    () => false,
  );
}
